// This file needs to be in two location, both in libs and app
// If something has to be changed in this file, it also needs to be changed in the other.
// frontend->apps->api->src->items->formCodeEnum
export enum FormCode {
  Safnmunur = 'SAFNMUN',
  KvikmyndirHlidraenar = 'KVIKH',
  KvikmyndirStafraenar = 'KVIKS',
  Gogn = 'GOGN',
  GognStafraen = 'GOGNGR',
  LtoBond = 'LTOB',
  Diskar = 'DISK',
  Kvikmyndir = 'KVIK',
}
